import type { FC, HTMLAttributes, ComponentProps } from 'react';
import Box from '@spotnana/pixel-react/dist/Box';
import Info from '@spotnana/pixel-react/dist/Icons/Info';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '@spotnana/blocks/src/Typography';
import { flex } from '@spotnana/blocks/src/utils/styling';
import { CheckoutInfoContainer } from 'src/app/flights/shared/CheckoutInfoContainer';

type TransProps = ComponentProps<typeof Trans>;

export type InfoItem = {
  titleKey?: string;
  contentKey: string;
  contentValues?: object;
  components?: TransProps['components'];
};

type AdditionalInfoProps = {
  infoItems: InfoItem[];
  translationNamespace?: string;
  type?: string;
} & HTMLAttributes<HTMLDivElement>;

/**
 * @deprecated
 * This component needs more work as a part of ongoing migration to Blocks,
 * currently is only good to use on Air Checkout.
 */
export const AdditionalInfo: FC<AdditionalInfoProps> = ({
  infoItems,
  translationNamespace,
  type,
  ...rest
}: AdditionalInfoProps) => {
  const { t } = useTranslation(translationNamespace);

  /** TODO AVIRAL: replace style tag with emotion/react, replace Box usage too */
  return (
    <CheckoutInfoContainer data-testid="additional-information" {...rest}>
      {infoItems.map(({ contentKey, titleKey, contentValues, components }: InfoItem) => (
        <div key={contentKey}>
          <Box display="flex" style={{ alignItems: 'center', marginBottom: '1rem' }}>
            {type === 'info' && (
              <Box mr={2} css={[flex.init]}>
                <Info width={16} height={16} />
              </Box>
            )}
            {titleKey && (
              <Typography variant="header5" as="h5">
                {t(titleKey)}
              </Typography>
            )}
          </Box>

          <Typography variant="body2" color="secondary">
            <Trans i18nKey={contentKey} t={t} values={contentValues} components={components} />
          </Typography>
        </div>
      ))}
    </CheckoutInfoContainer>
  );
};
